<template>
  <div id="AccruedLiabilityReport">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">Accrued Liability - Core</div>
          <div class="web-action-btn btn-groups text-right">
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                    <i class="fp-export"></i> Export
                </a>
            </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'accruedLiabilityReport'" ref="filterComponent" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'accruedLiabilityReport'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  title="Accrued Liability Report"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "AccruedLiabilityReport",
  metaInfo() {
            return {title: "Accrued Liability - Core | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action: 'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
                {
                    label: 'Facility',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Facility Description',
                    field: 'facility_desc',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Vendor Company',
                    field: 'vendor_company',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Vendor Number',
                    field: 'vendor_number',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true

                },
                {
                    label: 'Vendor Suffix',
                    field: 'vendor_suffix',
                    hidden:false,
                    fpFieldType:"text",
                    filterable: true
                },
                {
                    label: 'Vendor Name',
                    field: 'vendor_name',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text"

                },
                {
                    label: 'PO Date',
                    field: 'order_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'PO Number',
                    field: 'po_number',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"text"

                },
                {
                    label: 'Expected Date',
                    field: 'due_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true

                },
                {
                    label: 'Accrued Liability Balance',
                    field: 'accrued_liability_bal',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'AP Invoiced Amount',
                    field: 'ap_invoice_amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false
                },
                {
                    label: 'Received Amount',
                    field: 'received_amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: true

                },
                {
                    label: 'Adjusted Amount',
                    field: 'adjusted_amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'PO Type',
                    field: 'po_type',
                    hidden:false,
                    filterable: true,
                    fpFieldType:"option",
                    filterOptions:{
                      filterDropdownItems:["Inventory","Sublet","Miscellaneous"]
                    }
                },
                {
                    label: 'PO Status',
                    field: 'po_status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions:{
                      filterDropdownItems:['Accrued','Closed','Hold','Open','Partial','Reserved','Sent','Processed','Cancelled']
                    }
                },
                {
                    label: 'Receipt Status',
                    field: 'receipt_status',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: false,
                    sortable:false,
                },
                {
                    label: 'Outstanding',
                    field: 'outstanding',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: false,
                    sortable : true,
                },
                {
                    label: 'Posted After Period Amount',
                    field: 'posted_after_period_amount',
                    fpFieldType:"integer",
                    hidden:false,
                    type:'number',
                    filterable: false,
                    sortable : false,
                },
                {
                    label: 'Warehouse',
                    field: 'warehouse',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: false
                },
                {
                    label: 'User Create',
                    field: 'user_create',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true
                },
                {
                    label: 'Create Date',
                    field: 'create_date',
                    fpFieldType:"date",
                    hidden:false,
                    filterable: true
                },
                {
                    label: 'Period End Date',
                    field: 'period_end',
                    fpFieldType:"date",
                    filterable: false,
                    sortable:false,
                    fpMandatory:true,
                    hidden:true
                },
            ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'accrued_liability_report') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    loadList: function(){
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/accrued-liability-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action: self.action


        },
        success: function(data) {
          self.loading = false;

          if (data.status == "success") {


            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();

            } else {
                 if (data.content.row != undefined) {

                  self.rows = data.content.row;
                }

                self.totalRecords = data.content.totalRecords;
            }



          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'accrued-liability-report');
        }
      });

    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/AccruedLiabilityReport.vue